import {API_VERSION} from '@/utils/constants/commonConstants';
import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {buildQueryParams} from '@/utils/commons';

export const PERFECT_STORE_CONFIG = {
  ADD_DRAFT_PERFECT_STORE: {
    endPoint: 'perfect-store-targets',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  },
  UPDATE_DRAFT_PERFECT_STORE: {
    endPoint: 'perfect-store-targets',
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1
  },
  PUBLISH_PERFECT_STORE: {
    endPoint: 'perfect-store-targets',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  },
  UPDATE_PERFECT_STORE: {
    endPoint: 'perfect-store-targets',
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1
  },
  VALIDATE_PERFECT_STORE_NAME: {
    endPoint: 'perfect-store-targets/validate-name',
    method: HTTP_METHODS.GET,
    appendQueryParams: true
  },
  PERFECT_STORE_LIST: (queryParams) => ({
    endPoint: `perfect-store-targets/list?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  }),
  GET_PERFECT_STORE_DETAIL: (id) => ({
    endPoint: `perfect-store-targets/${encodeURIComponent(id)}`,
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1
  }),
  IMPORT_FIRST_POSITION_TARGET_FILE: (id) => ({
    endPoint: `first-position-targets/${encodeURIComponent(id)}/import-file`,
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1
  })
};
